<template lang="pug">
modal( id="oraclesmodal" name="oraclesmodal" :draggable="false" class="checkfits" :width="smallScreen ? '100%' : 760" :height="smallScreen ? '400' : 560" @before-close="beforeClose"  @before-open="beforeOpen" :class="smallScreen ? 'fullscreen' : ''")
  vue-context( ref="fitmenu" )
    li()
      a( href="#" @click.prevent="copyPageData('page', 'text')") Copy page to Clipboard
    li()
      a( href="#" @click.prevent="copyPageData('page', 'html')") Copy page to Clipboard (HTML)
    li()
      a( href="#" @click.prevent="copyPageData('page', 'md')") Copy page to Clipboard (Reddit/MD)
    li()
      a( href="#" @click.prevent="copyPageDataBB('page')") Copy page to Clipboard (BBCode)
    li
      a( href="#" @click.prevent="copyPageData('all', 'text')") Copy table to Clipboard
    li
      a( href="#" @click.prevent="copyPageData('all', 'html')") Copy table to Clipboard (HTML)
    li
      a( href="#" @click.prevent="copyPageData('all', 'md')") Copy table to Clipboard (Reddit/MD)
    li()
      a( href="#" @click.prevent="copyPageDataBB('all')") Copy table to Clipboard (BBCode)
    li
      a( href="#" @click.prevent="createImage('oracletable', 'png')") Save screenshot as PNG
    li
      a( href="#" @click.prevent="writeSheet()") Export table to XLS
    li
      a( href="#" @click.prevent="rawData()") Copy raw data
  vue-context( ref="oraclesmenu" )
    li()
      a( href="#" @click.prevent="copyPageData2('page', 'text')") Copy page to Clipboard
    li()
      a( href="#" @click.prevent="copyPageData2('page', 'html')") Copy page to Clipboard (HTML)
    li()
      a( href="#" @click.prevent="copyPageData2('page', 'md')") Copy page to Clipboard (Reddit/MD)
    li()
      a( href="#" @click.prevent="copyPageDataBB2('page')") Copy page to Clipboard (BBCode)
    li
      a( href="#" @click.prevent="copyPageData2('all', 'text')") Copy table to Clipboard
    li
      a( href="#" @click.prevent="copyPageData2('all', 'html')") Copy table to Clipboard (HTML)
    li
      a( href="#" @click.prevent="copyPageData2('all', 'md')") Copy table to Clipboard (Reddit/MD)
    li()
      a( href="#" @click.prevent="copyPageDataBB2('all')") Copy table to Clipboard (BBCode)
    li
      a( href="#" @click.prevent="createImage('oracletable', 'png')") Save screenshot as PNG
    li
      a( href="#" @click.prevent="writeSheet2()") Export table to XLS
    li
      a( href="#" @click.prevent="rawData2()") Copy raw data
  div#oracletable(:style="`height:${smallScreen ? '400px' : '560px'};display: inline-block;`")
    div.header Oracles
      n-button.closedialog(@click.native="closeModal()")
        i.fas.fa-times
    .row.content()
      .radio
        el-radio-group(v-model="radio" size="mini" fill="#f96332" @change="setpage()")
          el-radio-button(label=0) Mixed
          el-radio-button(label=1) 2 Way
          el-radio-button(label=2) 4 Way
          el-radio-button(label=3) Checkfit
      .col-12(v-if="radio != 3" :style="`xheight:${height}px; text-align: center;`" @contextmenu.prevent="$refs.oraclesmenu.open")
        el-table(:data='pageData' empty-text='No matches found')
          el-table-column(width='55' label=' ' class='index')
            div.index(slot-scope="{row}") {{ row.index }}
          el-table-column(width='565' label='' class='message')
            div.message(slot-scope="{row}" :class="radio === '2' ? 'shrink' : ''" v-tooltip="radio === '2' ? row.fullmsg : row.message") {{row.message}}
          el-table-column(width='70' class='distance') 
            div.distance(style="text-align: center;" slot-scope="{row}") {{ row.distance ? row.distance.toFixed(2) : 0 }}
      .col-12(v-if="radio == 3" :style="`height:${height}px; text-align: center;`" @contextmenu.prevent="$refs.fitmenu.open")
        el-table(:data='pageData' empty-text='No matches found')
          el-table-column(width='70px' label=' ' class='index')
            div.sample(slot-scope="{row}") {{ row.index }}
          el-table-column(width='540' label='' class='sample')
            div.sample(slot-scope="{row}" v-tooltip="{content:  row._row.replace(/_/g,' ').replace(':','   ').length > 58 ? row._row.replace(/_/g,' ').replace(':','   ') : '' , classes: [ 'modaltip' ]}") {{row._row.replace(/_/g,' ').replace(':','   ').length > 58 ? (row._row.replace(/_/g,' ').replace(':','   ')).substring(0,55) + '...' : row._row.replace(/_/g,' ').replace(':','   ') }}
          el-table-column(width='85' class='distance') 
            div.distance(style="text-align: center;" slot-scope="{row}") {{ row.distance ? row.distance.toFixed(2) : 0 }}
    .pagination(style="text-align: center; position: absolute; bottom: 25px; width: 100%;")
        n-pagination(:page-count="pages" v-model="defaultPagination" style="margin: auto;" v-on:input="log(defaultPagination)")
</template>
<script>
import domtoimage from 'dom-to-image-improved';
import {Table, TableColumn} from 'element-ui'
import { Button, Pagination } from '@/components'
import copy from 'copy-html-to-clipboard';
import table from 'table-builder'
import tablecss from '../../table.js'
export default {
  name: 'OraclesModal',
  components: {
      [Table.name]: Table,
          [TableColumn.name]: TableColumn,
          [Button.name]: Button,
          [Pagination.name]: Pagination
            },
  data () {
    return {
    changed: false,
		radio: '0',
    headers: ['Mixed', '2 Way', '4 Way', 'checkFit'],
    nearest: [],
    oracles: [],
    closable: false,
    smallScreen: window.innerWidth < 480 ? true : false,
    defaultPagination: 1,
    }
  },
  computed: {
    pageData: function() {
      var page = this.defaultPagination;
      var start = page * 10 - 10
      var end = start + 10;
      var pagedata = this.tableData.slice(start, end)
      pagedata.forEach((row, index) => {
      row.index = start + index + 1;
      })
      return pagedata;
    },
    tableData: function() {
    if ( this.radio !== '3' && this.oracles ) {
		if ( this.radio === '0' ) {
    return  this.oracles ? this.oracles : [];
		} else if (this.radio === '1') {
		return this.multi2 ? this.multi2 : []
		} else {
		return this.multi4 ? this.multi4 : []
		}
    } else {
    return this.nearest }
    },
    pages: function() {
    return this.tableData && this.tableData.length > 0 ? Math.ceil(this.tableData.length/10) : 0;
    },
    height: function() {
    let rowsize = this.smallScreen ? 47.5 * 0.7 : 47.5;
    return this.pageData.length > 0 ?  parseInt((this.pageData.length * rowsize) + 200) : 260;
    }
    },
  methods: {
        createImage(el, type) {
            let w = this;
            console.log('creating image: ', el);
            w.exporting = true;
            try {
                var filename = el === 'apex-wrapper' ? 'chart' : el;
                var node = document.getElementById(el);
                var style = el === 'table' ? {
                    marginTop: '-50px',
                    padding: 0
                } : el === 'chartresult' ? {
                    'margin-left': 'unset',
                    'width': '100%',
                    marginTop: '-35px',
                    paddingTop: '0px'
                } : el == 'chart' ? {
                    'margin': 0,
                    'width': '100%',
                    marginTop: '106.5px',
                    padding: 'unset',
                } : el === 'barchart' ? {
                    'margin': 0,
                    'width': '100%',
                    marginTop: '-10px',
                    padding: 'unset',
                    paddingLeft: '50px',
                    paddingRight: '10px'
                } : {
                    margin: 0,
                    padding: 0
                }
                if (type && type === 'svg') {
                    domtoimage.toSvg(node, {
                            bgcolor: this.theme ? '#14191f' : '#f2f2f2',
                            style: style
                        })
                        .then(function(blob) {
                            var img = new Image();
                            var svgBlob = new Blob([blob], {
                                type: "image/svg+xml;charset=utf-8"
                            });
                            var svgUrl = URL.createObjectURL(svgBlob);
                            img.src = svgUrl
                            console.log(style);
                            window.saveAs(blob, `${filename}.svg`);

                        });
                } else {
                    var style = el === 'table' ? {
                        marginLeft: 0,
                        marginTop: '-50px',
                        padding: 0,
                        paddingLeft: '50px',
                        paddingRight: '10px'
                    } : el === 'chartresult' ? {
                        'margin-left': 'unset',
                        'width': '100%',
                        marginTop: '-35px',
                        paddingTop: '0px'
                    } : el === 'chart' ? {
                        'margin-left': 'unset',
                        'width': '100%',
                        marginTop: '106.5px',
                        padding: 'unset'
                    } : el === 'barchart' ? {
                        'margin-left': 'unset',
                        'width': '100%',
                        marginTop: '-10px',
                        padding: 'unset',
                        paddingLeft: '50px',
                        paddingRight: '10px'
                    } : {
                        marginLeft: 0,
                        padding: 0
                    }
                console.log('style', style);
                    domtoimage.toBlob(node, {
                            bgcolor: this.theme ? '#181818' : 'white',
                            style: style
                        })
                        .then(function(blob) {
                            var img = new Image();
                            img.src = blob
                            window.saveAs(blob, `${filename}.png`);
                            w.exporting = false;
                        }).catch(err => {
                            w.exporting = false;
                        })
                }
            } catch (err) {
                w.exporting = false;
            }

        },
        logit() {
        },
				setpage() {
         this.defaultPagination = 1;
				},
         beforeOpen: function(evt) {
         console.log('params', evt.params);
				 this.radio = '0';
         this.defaultPagination = 1;
            let nearest = evt.params.nearest ? [...evt.params.nearest] : []
            nearest.map( x => { x._row = x._row.split(':')[0].split(']').length > 1 ? x._row.split(' [')[1].split(':')[0].replace(/\]/,'') + '_' +  x._row.split(' [')[0] + x._row.split(']')[1] : x._row; x.distance = x.distance && typeof(x.distance) == 'number' ?  parseFloat(x.distance.toFixed(2)) : x.distance; return x })
            this.nearest = nearest
            this.oracles = evt.params.oracles ? evt.params.oracles : []
            this.multi2 = evt.params.multi2 ? evt.params.multi2 : []
            this.multi4 = evt.params.multi4 ? evt.params.multi4 : []
        },
        getXLS: () => {
            return new Promise((resolve, reject) => {
                if (!window.XLSX) {
                    let script = document.createElement('script')
                    script.onload = () => {
                        resolve(true)
                    }
                    script.async = true
                    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.15.2/xlsx.core.min.js'
                    document.head.appendChild(script)
                } else {
                    resolve(true)
                }
            })
        },
        writeSheet2() {
            this.$eventBus.$emit('spinner', 'run')
            if (this.tableData) {
                var data = this.tableData;
                var rows = [];
                let header = `${this.headers[this.radio]} Oracles`
                var columns = [header, 'Distance']
                rows.push(columns);
                data.forEach(function(p) {
                    var result = []
                    result.push(p.fullmsg ? p.fullmsg : p.message);
                    result.push(p.distance);
                    rows.push(result)
                })
                this.getXLS().then((res) => {
                var wb = XLSX.utils.book_new();
                var ws = XLSX.utils.aoa_to_sheet(rows);
                XLSX.utils.book_append_sheet(wb, ws, "table");
                XLSX.writeFile(wb, "data.xlsx", {
                    compression: true
                });
                }).catch(err => {
            this.$eventBus.$emit('spinner', 'stop')
                    console.log(err)
                })
            } else {
                console.log('Nothing to export..')
            }
            this.$eventBus.$emit('spinner', 'stop')
        },
        rawData2() {
            if (this.tableData) {
                var data = []
                this.tableData.forEach( (oracle, index) => {
                var obj = {}
            let header = `${this.headers[this.radio]} Oracles`.toLowerCase();
                obj[header] =  {...oracle}.fullmsg ?  {...oracle}.fullmsg : {...oracle}.message
                obj.distance = {...oracle}.distance
                obj.rank = index + 1;
                data.push(obj);
                })
                let prettyJSON = JSON.stringify(data, null, 2)
            copy(prettyJSON, {
                asHtml: false
            });

            } else {
                console.log('Nothing to copy..')
            }
        },
        copyPageDataBB2(page) {
            var data = page === 'page' ? this.pageData : this.tableData;
            var headers = {}
            var tabledata = []
            headers.mix = `${this.headers[this.radio]} Oracles`
            headers.distance = 'Distance'
            data.forEach(oracle => {
                var obj = {};
                obj.mix = oracle.fullmsg ? oracle.fullmsg : oracle.message;
                obj.distance = oracle.distance;
                tabledata.push(obj)
            })
            var copyhtml = new table().setHeaders(headers).setData(tabledata).render()
            copyhtml = copyhtml.replace(/</g,'[').replace(/>/g,']')
            var replace = new RegExp(' class=.*?]','g')
            copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g,']').replace(/:/g,': ')
            copyhtml = `[size=1]${copyhtml}[/size]`
            copy(copyhtml, {
                asHtml: false,
            });
        },
        copyPageData2(page, type) {
            let w = this;
            var data = page === 'page' ? this.pageData : this.tableData;
            var headers = {}
            var tabledata = []
            headers.mix = `${this.headers[this.radio]} Oracles`
            headers.distance = 'Distance'
            data.forEach(oracle => {
                var obj = {};
                obj.mix = oracle.fullmsg ? oracle.fullmsg : oracle.message;
                obj.distance = oracle.distance;
                tabledata.push(obj)
            })
            var copyhtml = new table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            let copytext = this.$yaml.stringify(tabledata,2).replace(/-\n/g,'\n').replace(/'/g,'')
            if ( type && type == 'md' ) {
            let table = []
            let tablehead = Object.keys(headers).map( x => headers[x])
            table.push(tablehead);
            tabledata.map( x => {
            let row = []
            Object.keys(headers).map( y => { row.push(typeof(x[y]) == 'string' ? x[y].replace('<b>','').replace('</b><br/><br/>','').replace('<br/>', ' ') : x[y]) })
            table.push(row);
            })
            let copyhtml = w.$mdtable(table, { align: ['l', 'l', 'l']})
            copy(copyhtml, {
                asHtml: false
            });
            } else if ( type === 'text' ) {
            copy(copytext, {
                asHtml: false,
            });
            } else {
            copy(copyhtml, {
                asHtml: true,
            });
            }
        },
        writeSheet() {
            this.$eventBus.$emit('spinner', 'run')
            if (this.tableData) {
                var data = this.tableData;
                var rows = [];
                var columns = ['sample', 'distance']
                rows.push(columns);
                data.forEach(function(p) {
                    var result = []
                    result.push(p._row);
                    result.push(p.distance);
                    rows.push(result)
                })
                var wb = XLSX.utils.book_new();
                var ws = XLSX.utils.aoa_to_sheet(rows);
                XLSX.utils.book_append_sheet(wb, ws, "table");
                XLSX.writeFile(wb, "data.xlsx", {
                    compression: true
                });
            } else {
                console.log('Nothing to export..')
            }
            this.$eventBus.$emit('spinner', 'stop')
        },
        rawData() {
            if (this.tableData) {
                var data = []
                this.tableData.forEach( (sample, index) => {
                var obj = {}
                obj.sample =  {...sample}.sample ?  {...sample}.sample :  {...sample}._row
                obj.distance = {...sample}.distance
                obj.rank = index + 1;
                data.push(obj);
                })
                let prettyJSON = JSON.stringify(data, null, 2)
            copy(prettyJSON, {
                asHtml: false
            });

            } else {
                console.log('Nothing to copy..')
            }
        },
        copyPageDataBB(page) {
            var data = page === 'page' ? this.pageData : this.tableData;
            var headers = {}
            var tabledata = []
            headers.sample = 'Sample'
            headers.distance = 'Distance'
            data.forEach(sample => {
                var obj = {};
                obj.sample = sample._row.replace(/_/g,' ');
                obj.distance = sample.distance;
                tabledata.push(obj)
            })
            var copyhtml = new table().setHeaders(headers).setData(tabledata).render()
            copyhtml = copyhtml.replace(/</g,'[').replace(/>/g,']')
            var replace = new RegExp(' class=.*?]','g')
            copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g,']').replace(/:/g,': ')
            copyhtml = `[size=1]${copyhtml}[/size]`
            copy(copyhtml, {
                asHtml: false,
            });
        },
        copyPageData(page, type) {
        let w = this;
            var data = page === 'page' ? this.pageData : this.tableData;
            var headers = {}
            var tabledata = []
            headers.sample = 'Sample'
            headers.distance = 'Distance'
            data.forEach(sample => {
                var obj = {};
                obj.sample = sample._row
                obj.distance = sample.distance;
                tabledata.push(obj)
            })
            var copyhtml = new table({
                'class': 'tableHTML'
            }).setHeaders(headers).setData(tabledata).render()
            let copytext = this.$yaml.stringify(tabledata,2).replace(/-\n/g,'\n').replace(/'/g,'')
            if ( type && type == 'md' ) {
            let table = []
            let tablehead = Object.keys(headers).map( x => headers[x])
            table.push(tablehead);
            tabledata.map( x => {
            let row = []
            Object.keys(headers).map( y => { row.push(typeof(x[y]) == 'string' ? x[y].replace('<b>','').replace('</b><br/><br/>','').replace('<br/>', ' ') : x[y]) })
            table.push(row);
            })
            let copyhtml = w.$mdtable(table, { align: ['l', 'l', 'l']})
            console.log(copyhtml);
            copy(copyhtml, {
                asHtml: false
            });
            } else if ( type === 'text' ) {
            copy(copytext, {
                asHtml: false,
            });
            } else {
            copy(copyhtml, {
                asHtml: true,
            });
            }
        },
show: function(params) {
var w = this;
var title = params.title ? params.title : 'Alert!'
var text = params.text ? params.text : 'Message received...'
var buttons = [ 
    {
      title: 'Continue',
      default: false,    // Will be triggered by default if 'Enter' pressed.
      handler: () => { w.closable = true; 
      w.$modal.hide('dialog');
      w.closeModal(true);
      } 
    },
    {
      title: 'Cancel',
      default: true,
      handler: () => { w.closable = false;w.$modal.hide('dialog'); } // Button click handler
    }
 ]
this.$modal.show('dialog', {
  title: title,
  text: text,
  class: params.class ? params.class : undefined,
  buttons: buttons
})
},
    log: function(params, row) {
    return;
    },
    beforeClose: function(event) {
        this.$eventBus.$emit('appEvents', {
            exec: 'resetTip',
            component: 'g25'
        });
    },
    closeModal: function(flag) { 
    this.$modal.hide('oraclesmodal') 
      }
          },
  created () {
  }
}
</script>
<style lang="scss">

#oraclesmodal .el-table__header-wrapper {
display: none;
}

#oraclesmodal .el-table .shrink {
font-size: 0.95em;
} 
#oraclesmodal .radio {
width: 100%;
margin-top: 35px;
}
#oraclesmodal .radio .el-radio-group {
width: 100%;
text-align: center;
}
#oraclesmodal .radio .el-radio-button, #oraclesmodal .radio .el-radio-button__inner {
    display: inline-block;
    position: relative;
    outline: 0;
    width: 100px;
    margin-left: 1px;
}
#oraclesmodal .radio *:focus, #oraclesmodal .radio *:focus-within, #oraclesmodal .radio *:active {
outline:0;
}

div.form-check {
    position: absolute;
    top: -7px;
    left: -9px;
    display: inline-block;
    color: black;
    z-index: 999;
}
.form-check .form-check-sign::before, .form-check .form-check-sign::after {
    font-weight: 700;
    color: black;
    background-color: #6c848db8;
    background-color: white;
    border: 1px solid #837c7c;
        width: 20px;
            height: 20px;
}

.v--modal .header {
    position: absolute;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    padding-top: 10px;
    z-index: 2;
    width: 100%;
        height: 40px;
            color: black;
            }

.form-check .form-check-sign.active::before, .form-check .form-check-sign.active::after {
    /*background-color: #00678d;*/
    }
.form-check .form-check-label {
    font-size: 10px;
    text-transform: uppercase;
    color: white;
    font-weight: 700;
    line-height: 20px;
}

div.modalHeader {
text-align: center;
font-weight: 300;
padding-top: 11px;
position: absolute;
font-family: Lato, "Helvetica Neue", Arial, sans-serif;
font-size: 18.2px;
z-index: 2;
line-height: 22px;
margin-bottom: 0;
}

.oracles.v--modal-overlay {
z-index: 2000;
}

#app .el-table .cell {
line-height: 14px;
}

#app .oracles .v--modal button.closedialog:hover {
box-shadow: none;
}
#app .oracles .v--modal button.closedialog:active {
background: #9797971c;
}

#app .oracles .v--modal button.closedialog {
    background: transparent;
    color: gray;
        position: absolute;
            top: -11px;
                right: -8px;
                }

#app .oracles .buttons button.primary {
width: 90px;
}

#app .oracles .el-table {
padding-top: 0;
}
#app #oraclesmodal .el-table .cell {
cursor: default;
font-family: helvetica;
color: #555;
}

#app .oracles .el-table__empty-text {
    line-height: 24px;
        font-size: 18px;
            width: 70%;
                margin-left: -42px;
                    color: #909399;
                    }
#app .el-table::before { height: 0px; }
.oracles {
border-radius: 5px;
}

.oracles.fullscreen .v--modal {
border-radius: 0px;
}

#oraclesmodal.fullscreen .row.content {
zoom: 70%;
}

.oracles .col-12 {
transition: height 0.3s;
}

.oracles .row.content {
margin-top: 20px;
}

.oracles .v--modal {
transition: top 0.3s;
}
#oraclesmodal .v--modal button i.fas.fa-times {
color: gray;
}
#oraclesmodal .col-12 .el-table {
padding-top: 10px;
}
#oraclesmodal .radio {
margin-top: 50px;
}
</style>
